import { ProTable } from '@ant-design/pro-components';
import { Button, Flex, Tag, Typography } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { filterHarnessMembers, harnessDisplayStatuses } from '../utils/harness';
import HarnessMemberDrawer from './HarnessMemberDrawer';

const HarnessInstancesTable = ({ instances, loading, toolbar, feedback, emptyText }) => {
  const [query, setQuery] = useState({});
  const [selectedMember, setSelectedMember] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const columns = [
    {
      title: '成员',
      dataIndex: 'memberName',
      fieldProps: { 'aria-label': '成员' },
      ellipsis: true,
      renderText: (name) => name || '未命名成员',
    },
    {
      title: '当前版本',
      dataIndex: 'tag',
      width: 200,
      search: false,
      render: (_, record) => (
        <Flex gap="small" wrap>
          <Typography.Text>{record.tag || '—'}</Typography.Text>
          {record.versionMatchesTarget === false && <Tag color="warning">待更新</Tag>}
        </Flex>
      ),
    },
    {
      title: '运行状态',
      dataIndex: 'displayStatus',
      fieldProps: { 'aria-label': '运行状态' },
      width: 140,
      valueType: 'select',
      valueEnum: harnessDisplayStatuses,
    },
    {
      title: '操作',
      valueType: 'option',
      width: 80,
      fixed: 'right',
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedMember(record.memberId);
            setDetailsOpen(true);
          }}
        >
          详情
        </Button>
      ),
    },
  ];
  return (
    <>
      <ProTable
        rowKey="memberId"
        headerTitle="成员运行情况"
        columns={columns}
        dataSource={filterHarnessMembers(instances, query)}
        loading={loading}
        search={{ defaultCollapsed: false, labelWidth: 'auto', span: { xs: 24, sm: 12, md: 8 } }}
        onSubmit={setQuery}
        onReset={() => setQuery({})}
        toolBarRender={() => toolbar}
        tableExtraRender={() => feedback}
        options={false}
        pagination={{ defaultPageSize: 10, showSizeChanger: true }}
        scroll={{ x: 640 }}
        locale={{ emptyText }}
      />
      {selectedMember && (
        <HarnessMemberDrawer
          member={instances.find((row) => row.memberId === selectedMember)}
          open={detailsOpen}
          onClose={() => setDetailsOpen(false)}
          onClosed={() => setSelectedMember(null)}
        />
      )}
    </>
  );
};
HarnessInstancesTable.propTypes = {
  instances: PropTypes.arrayOf(PropTypes.shape({ memberId: PropTypes.string.isRequired }))
    .isRequired,
  loading: PropTypes.bool,
  toolbar: PropTypes.arrayOf(PropTypes.node).isRequired,
  feedback: PropTypes.node,
  emptyText: PropTypes.string.isRequired,
};
export default HarnessInstancesTable;
